import { Alert, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

function InsightContactSmsDisclosure() {
  return (
    <Alert severity="info" sx={{ marginBottom: 1 }}>
      <FormattedMessage
        id="INSIGHT_CONTACT_SMS_OPT_IN_DESCRIPTION"
        defaultMessage="By selecting SMS Opt-In, you agree to receive text message notifications about your jobs and updates from Service Xcelerator."
      />
      <ul style={{ margin: 0, padding: '10px 0 0 17px' }}>
        <li>
          <FormattedMessage
            id="INSIGHT_CONTACT_SMS_OPT_IN_DESCRIPTION_1"
            defaultMessage="Your phone number will not be shared with the customer or sold or shared with third parties for marketing or promotional purposes."
          />
        </li>
        <li>
          <FormattedMessage
            id="INSIGHT_CONTACT_SMS_OPT_IN_DESCRIPTION_2"
            defaultMessage="Msg & Data rates may apply. Msg frequency varies based on service activity. Reply HELP for help."
          />
        </li>
        <li>
          <FormattedMessage
            id="INSIGHT_CONTACT_SMS_OPT_IN_DESCRIPTION_3"
            defaultMessage="You can opt out anytime by changing this setting or replying STOP to any SMS message."
          />
        </li>
      </ul>
      <Stack sx={{ justifySelf: 'start', mt: 2 }} direction="row" spacing={2}>
        <a target="_blank" href="/legal/terms">
          <FormattedMessage id="TERMS" defaultMessage="Terms" />
        </a>
        <a target="_blank" href="/legal/privacy">
          <FormattedMessage id="PRIVACY" defaultMessage="Privacy" />
        </a>
      </Stack>
    </Alert>
  );
}

export default InsightContactSmsDisclosure;
